import { PersonaType, CommodityStatusCode, CrewMember, CommodityStats } from '@bechtel/types';
import { WeldFilterInput } from '~/search-bar/types';
export interface WeldListItemTab {
  label: string;
  value: CommodityStatusCode;
  visible: boolean;
}
export interface WeldTabProps {
  personaType: PersonaType;
  weldFilter?: WeldFilterInput;
  crewMember: CrewMember;
  weldTypeId: string | undefined;
  fitupStatusStats?: CommodityStats[];
  loading?: boolean;
  weeklyStatusStats?: CommodityStats[];
}
